'use client'

import React from 'react'

import { Box, Text } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { AiOperatorIcon } from '../Icon'
import {
  headerIconStyles,
  headerStyles,
  headerSubtitleStyles,
  headerTextGroupStyles,
  headerTitleStyles,
} from './ReasoningTrail.styles'
import { REASONING_TRAIL_COPY } from './constants'

type ReasoningTrailHeaderProps = {
  colorScheme: ColorScheme
  reviewedStepsLabel?: string
}

export const ReasoningTrailHeader = ({
  colorScheme,
  reviewedStepsLabel,
}: ReasoningTrailHeaderProps) => (
  <Box {...headerStyles}>
    <Box {...headerIconStyles(colorScheme)}>
      <AiOperatorIcon />
    </Box>
    <Box {...headerTextGroupStyles}>
      <Text {...headerTitleStyles(colorScheme)}>
        {REASONING_TRAIL_COPY.BRAND}
      </Text>
      <Text {...headerSubtitleStyles(colorScheme)}>
        {reviewedStepsLabel ?? REASONING_TRAIL_COPY.reviewedSteps}
      </Text>
    </Box>
  </Box>
)
